import * as React from "react";
import FluidFrame from "../FluidFrame";
import DefaultHead from "../DefaultHead";

interface Props {
  onExpand: () => void;
  imageUrl: string;
  text: string;
  height: number;
  width: number;
  textColor: string;
  textSize: number;
  backgroundColor: string;
  availabilityClassName: string;
}

class CustomLauncher extends React.Component<Props, {}> {
  renderIcon() {
    if (this.props.imageUrl) {
      return (
        <img
          src={this.props.imageUrl}
          alt=""
          role="presentation"
          style={{ height: "100%", width: "100%" }}
        />
      );
    }

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
      >
        <path
          d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
          fill={this.props.textColor}
        />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    );
  }

  public render() {
    return (
      <React.Fragment>
        <div className="velaro-launcher-frame velaro-custom-launcher-frame">
          <FluidFrame head={<DefaultHead />}>
            <div role="dialog">
              <h1 className="velaro-skip">Launch Live Chat</h1>
              <div
                className={`velaro-custom-launcher ${this.props.availabilityClassName}`}
                tabIndex={0}
                onClick={this.props.onExpand}
                onKeyDown={e => {
                  return e.keyCode !== 13 || this.props.onExpand();
                }}
                style={{ backgroundColor: this.props.backgroundColor }}
                aria-label="Open Live Chat"
                role="button"
              >
                <span
                  className="icon"
                  style={{
                    height: this.props.height,
                    width: this.props.width
                  }}
                  aria-hidden="true"
                >
                  {this.renderIcon()}
                </span>
                {this.props.text && (
                  <span
                    className="text"
                    style={{
                      color: this.props.textColor,
                      fontSize: this.props.textSize + "em"
                    }}
                    aria-hidden="true"
                  >
                    {this.props.text}
                  </span>
                )}
              </div>
            </div>
          </FluidFrame>
        </div>
      </React.Fragment>
    );
  }
}

export default CustomLauncher;
